import { useCallback, useState, useEffect } from "react";
import {loadStripe} from '@stripe/stripe-js';
import {
  EmbeddedCheckoutProvider,
  EmbeddedCheckout
} from '@stripe/react-stripe-js';
import { useNavigate,
  useLocation,
  BrowserRouter as Router,
  Route,
  Routes,
  useSearchParams
} from "react-router-dom";
import { Grid, CircularProgress, Alert } from '@mui/material';
import ThankYouDialog from "./components/ThankYouDialog";
import PurchasableItem from "./components/PurchasableItem";
import Background from "./components/Background";

// Make sure to call `loadStripe` outside of a component’s render to avoid
// recreating the `Stripe` object on every render.
// This is your test publishable API key.
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);
const baseUrl = process.env.REACT_APP_API_BASE_URL;

console.log(process.env.REACT_APP_STRIPE_PUBLIC_KEY);
console.log(baseUrl);


const Home = () => {
    const navigate = useNavigate();
    const [searchParams, ] = useSearchParams();
    const vmId = searchParams.get("vm_id") ?? "1";

    const [status, setStatus] = useState(null);
    const [quantity, setQuantity] = useState(1);
    const [open, setOpen] = useState(false);

    const [product, setProduct] = useState(null);
    const [loading, setLoading] = useState(true);


    useEffect(() => {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const sessionId = urlParams.get('session_id');

        if (!sessionId || status) {
            return;
        }

        fetch(`${baseUrl}/session-status?session_id=${sessionId}`)
        .then((res) => res.json())
        .then((data) => {
            setStatus(data.status);
            setQuantity(data.quantity);
        });
    }, [status]);

    useEffect(() => {
        setLoading(true);
        fetch(`${baseUrl}/get-product?vm_id=${vmId}`)
            .then((res) => {
                if (!res.ok) throw new Error("Network response was not ok");
                return res.json();
            })
            .then((data) => {
                setProduct(data);
            })
            .catch((err) => {
                console.error("Failed to load product", err);
            })
            .finally(() => setLoading(false));
    }, [vmId]);
    
    useEffect(() => {
        if (!status) return;

        if (status === 'open') {
            setStatus(null);
            navigate("/checkout", { state: { vmId, quantity, retry: true } });
            return;
        }

        if (status === 'complete') {
            setStatus("handled");
            navigate(`?vm_id=${vmId}`);
            return;
        }

        if (status === "handled" && !open) {
            setStatus(null);
            setOpen(true);
        }
    }, [status, vmId, open, navigate, quantity]);



    const handleClose = () => {
        setOpen(false);
    };

    if (loading) {
        return (
            <Background>
                <Grid
                    container
                    justifyContent="center"
                    alignItems="center"
                    style={{ height: "80vh" }}
                >
                    <CircularProgress />
                </Grid>
            </Background>
        );
    }


    return (
        <Background>
            <Grid container spacing={2} justifyContent="center" sx={{
                    overflowY: 'auto',
                    maxHeight: '90vh',
            }}>
                <PurchasableItem
                    name={product.name}
                    price={product.price}
                    imgUrl={product.img_url}
                    vmId={vmId}
                />
                <ThankYouDialog
                    open={open}
                    onClose={handleClose}
                />
            </Grid>
        </Background>
    );
};

const CheckoutForm = () => {
    const location = useLocation();
    const { vmId, quantity, retry } = location.state || {};

    const fetchClientSecret = useCallback(() => {
        // Create a Checkout Session with vmId and quantity
        return fetch(`${baseUrl}/create-checkout-session`, {
            method: "POST",
            headers: {
            "Content-Type": "application/json"
            },
            body: JSON.stringify({ vm_id: vmId, quantity: quantity })
        })
            .then((res) => res.json())
            .then((data) => data.clientSecret);
    }, [vmId, quantity]);

    const options = { fetchClientSecret };

    return (
        <Background>
            <div
                style={{
                    width: "90%",
                    boxShadow: "0 4px 24px rgba(0,0,0,0.08)",
                    backgroundColor: "white",
                    pointerEvents: "auto",
                    borderRadius: "15px",
                    paddingTop: "15px",
                    paddingBottom: "15px",
                    marginTop: "10%",
                    marginBottom: "10%",
                    marginLeft: "auto",
                    marginRight: "auto",
                }}
            >
                {retry && (
                    <Alert severity="error" variant="filled">Something went wrong. Please try again!</Alert>
                )}
                <EmbeddedCheckoutProvider
                    stripe={stripePromise}
                    options={options}
                >
                    <EmbeddedCheckout />
                </EmbeddedCheckoutProvider>
            </div>
        </Background>
    );
};


const App = () => {
  return (
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/checkout" element={<CheckoutForm />} />
        </Routes>
      </Router>
  )
}

export default App;